import { Lock } from 'lucide-react';
import { cn } from '@/lib/cn';

export interface PaywallLockProps {
  className?: string;
  /** Visual size variant. */
  size?: 'sm' | 'md';
  /** Optional label rendered next to the lock — defaults to "Premium". */
  label?: string;
}

/**
 * Soft amber lock chip used to mark a card or button as gated behind a
 * paid plan. Pair the chip with a `usePaywall().openPaywall(feature)`
 * click handler on the parent affordance so the click that lands on the
 * locked element opens the upgrade modal.
 *
 * Aria-hidden by default — the surrounding link/button should already
 * carry the locked-state semantics in its accessible name.
 */
export function PaywallLock({ className, size = 'sm', label = 'Premium' }: PaywallLockProps) {
  const isMd = size === 'md';
  return (
    <span
      aria-hidden
      className={cn(
        'inline-flex shrink-0 items-center gap-1 rounded-full border border-amber-200 bg-amber-50 font-semibold text-amber-700',
        isMd ? 'px-2.5 py-1 text-[12px]' : 'px-2 py-0.5 text-[11px]',
        className,
      )}
    >
      <Lock className={isMd ? 'h-3.5 w-3.5' : 'h-3 w-3'} />
      {label}
    </span>
  );
}
